import { SectionHeader, BookNowButton } from "./Shared";
import { Tag, Repeat, Users, ArrowUpRight } from "lucide-react";

const OFFERS = [
  {
    id: "first-service",
    icon: Tag,
    badge: "New Clients",
    title: "$20 off your first service",
    desc: "Try the lab. New-client discount automatically applied at booking.",
    note: "Excludes laundry-only services.",
    accent: true,
  },
  {
    id: "recurring",
    icon: Repeat,
    badge: "Maintenance Plans",
    title: "Save on recurring cleans",
    desc: "Weekly, bi-weekly, or monthly schedules — discounted rates locked in.",
    note: "Weekly · Bi-weekly · Monthly",
  },
  {
    id: "referral",
    icon: Users,
    badge: "Refer a Friend",
    title: "Give $20, get $20",
    desc: "Send a friend our way — they get $20 off their first clean, and you get $20 off any service (not just your first).",
    note: "Applied as credit after their first booking.",
  },
];

export const Offers = () => {
  return (
    <section
      id="offers"
      data-testid="offers-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <SectionHeader
            eyebrow="Offers · the incentives"
            title={
              <>
                Save while you{" "}
                <span className="text-[#00E5FF] italic font-light">
                  clean smarter.
                </span>
              </>
            }
            sub="Discounts for new clients, recurring plans, and friends who send friends."
          />
          <BookNowButton variant="secondary" testId="offers-book-now" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {OFFERS.map((offer) => {
            const Icon = offer.icon;
            return (
              <div
                key={offer.id}
                data-testid={`offer-${offer.id}`}
                className={`relative rounded-3xl border p-7 sm:p-8 flex flex-col overflow-hidden group transition-all duration-500 ${
                  offer.accent
                    ? "border-[#00E5FF]/40 bg-gradient-to-br from-[#00E5FF]/10 via-black to-black hover:border-[#00E5FF]"
                    : "border-white/10 bg-[#0A0A0A] hover:border-[#00E5FF]/40"
                }`}
              >
                {offer.accent && (
                  <div className="absolute -top-20 -right-20 h-52 w-52 rounded-full bg-[#00E5FF]/20 blur-[80px] pointer-events-none" />
                )}

                <div className="relative flex items-center justify-between">
                  <span
                    className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-[10px] font-mono uppercase tracking-[0.2em] ${
                      offer.accent
                        ? "bg-[#00E5FF] text-black"
                        : "bg-white/5 text-white/60 border border-white/10"
                    }`}
                  >
                    {offer.badge}
                  </span>
                  <Icon
                    size={20}
                    className={offer.accent ? "text-[#00E5FF]" : "text-white/40"}
                  />
                </div>

                <h3 className="relative mt-8 font-display text-2xl sm:text-[28px] font-semibold tracking-tight leading-tight">
                  {offer.title}
                </h3>
                <p className="relative mt-3 text-sm text-white/60 font-body leading-relaxed flex-1">
                  {offer.desc}
                </p>
                <div className="relative mt-6 pt-5 border-t border-white/10 flex items-center justify-between">
                  <span className="text-xs font-mono uppercase tracking-[0.18em] text-white/40">
                    {offer.note}
                  </span>
                  <ArrowUpRight
                    size={16}
                    className="text-white/40 group-hover:text-[#00E5FF] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  />
                </div>
              </div>
            );
          })}
        </div>

        <p className="mt-8 text-xs font-mono uppercase tracking-[0.18em] text-white/35 text-center">
          Offers cannot be combined. Discounts applied at booking.
        </p>
      </div>
    </section>
  );
};
